import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { initStoreSync, storeAvailable } from "./storekit";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Real Apple subscriptions: once an authenticated user exists on iOS,
  // attach the StoreKit transaction listener and converge entitlements
  // (launch, relaunch, reinstall, renewals, unfinished transactions).
  useEffect(() => {
    if (user && storeAvailable()) initStoreSync();
  }, [user]);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("asmr_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("asmr_token");
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("asmr_token", data.token);
    const me = await refresh();
    return me;
  };

  const register = async (email, password) => {
    const { data } = await api.post("/auth/register", { email, password });
    localStorage.setItem("asmr_token", data.token);
    const me = await refresh();
    return me;
  };

  const logout = () => {
    localStorage.removeItem("asmr_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
